<template>
  <div class="succ-content">
    <svg-icon icon="ic-nodata-mini" class="succ-featured" width="130" height="100" />
    <div class="succ-content mb-8">{{ $t('data_not_available') }}</div>
  </div>
</template>

<script>
export default {
  name: 'NoData'
};
</script>

<style lang="scss" scoped>
.succ {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-family: Montserrat;

  &-content {
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-top: 10px;
    padding: 10px;
    font-size: 16px;
  }
}
</style>
